'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');
var constants = require('../../constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Menu = styled__default["default"].ul(({ grid }) => {
  const {
    navigationTextAlign,
    mobileMenuItemSpacing,
    mobileNavigationJustifySelf,
    paddingRight,
    mobileNavigationTextAlign,
    backgroundOverlayOpacity,
    mobileBackground
  } = grid;
  return `
    padding-left: unset;
    display: inline-flex;
    flex-flow: row wrap;
    row-gap: 16px;
    align-items: center;
    height: 100%;
    text-align: ${navigationTextAlign};
    list-style: none;
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px) {
      position: absolute;
      top: 100%;
      right: 0;
      left: 0;
      z-index: 1;
      display: grid;
      grid-gap: ${mobileMenuItemSpacing || 16}px 0;
      justify-self: ${mobileNavigationJustifySelf};
      width: auto;
      height: 0;
      max-height: 450px;
      padding: ${mobileMenuItemSpacing || 16}px ${mobileMenuItemSpacing || 16}px ${mobileMenuItemSpacing || 16}px ${paddingRight}px;
      margin: 0;
      overflow-y: auto;
      text-align: ${mobileNavigationTextAlign};
      pointer-events: none;
      background-size: cover;
      box-shadow: 0 6px 14px -14px #0000001a;
      opacity: 0;
      transform: translateY(-1em);
      transition-timing-function: cubic-bezier(.45,0,.1,1);
      transition-duration: .2s;
      transition-property: opacity,transform;
      background: linear-gradient(rgba(0,0,0,${backgroundOverlayOpacity}),rgba(0,0,0,${backgroundOverlayOpacity})),${mobileBackground} no-repeat top;
  
      &.open {
        height: auto;
        pointer-events: auto;
        opacity: 1;
        transform: translate(0);
        transition-timing-function: cubic-bezier(.45,0,.1,1);
        transition-duration: .2s;
        transition-property: opacity,transform;
      }
    };
  `;
});

exports.Menu = Menu;
